export const TypeContractOptions = [
  { label: 'Término Fijo', value: 'termino_fijo' },
  { label: 'Término Indefinido', value: 'termino_indefinido' },
  { label: 'Obra o Labor', value: 'obra_o_labor' },
  { label: 'Prestación de Servicios', value: 'prestacion_servicios' },
  { label: 'Aprendizaje', value: 'aprendizaje' },
  {
    label: 'Trabajo Ocasional, Accidental o Transitorio',
    value: 'ocasional_accidental_transitorio',
  },
  { label: 'Contrato de Trabajo por Temporada', value: 'temporada' },
  { label: 'Contrato de Trabajo a Domicilio', value: 'trabajo_domicilio' },
  { label: 'Contrato de Trabajo con Teletrabajo', value: 'teletrabajo' },
  { label: 'Contrato de Trabajo con Trabajo Remoto', value: 'trabajo_remoto' },
  { label: 'Contrato de Trabajo con Trabajo en Casa', value: 'trabajo_en_casa' },
  { label: 'Otro', value: 'otro' },
];
